<template>
  <div>
    {{config.type}}
    {{config.label}}
  </div>
</template>

<script>
export default {
  name: "image",
  components: {},
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
